import { ReactNode } from "react";

interface TelefoneRootProps {
  children?: ReactNode;
}

export function TelefoneRoot({ children }: TelefoneRootProps) {
  return (
    <div className="flex w-72 flex-col items-center self-center text-gray-600">
      {children}
    </div>
  );
}
